<div>
  {{ sales$ | async }}
</div>
